import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import Toggle from './../Toggle';
import RadioGroup from '../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { saloon_view02ImageOptions } from './views/Saloon_view02'

class X56Fabric extends Component {
    constructor(props) {
        super(props);
        this.handleFabricChange = this.handleFabricChange.bind(this);
		this.handleLayoutChange = this.handleLayoutChange.bind(this);
		this.handleLeatherHandlesChange = this.handleLeatherHandlesChange.bind(this);
    }


    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Fabric = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.GalleyLayout = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
		}
	}

	handleLeatherHandlesChange(event) {
		let configuration = this.props.configuration;
		configuration.LeatherHandles = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

		if (this.props.onChange) {
				this.props.onChange(configuration);
		}

    }

    render() {
		let imageOptions = saloon_view02ImageOptions;

        let image = <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

					<h1><Trans defaults='SALOON' /></h1>

					<h2><Trans defaults='Layout' /></h2>
					<RadioGroup label={this.props.configuration.GalleyLayout.label} options={this.props.layoutOptions} value={this.props.configuration.GalleyLayout} onChange={this.handleLayoutChange} />

					
					<h2><Trans defaults='Fabrics' /></h2>
					<MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.Fabric.label} value={this.props.configuration.Fabric} onChange={this.handleFabricChange} />

					<h2><Trans defaults='Options' /></h2>

					<Toggle checked={this.props.configuration.LeatherHandles.value === 2} onChange={this.handleLeatherHandlesChange}>
						<Trans defaults='Handles with leather cover' />
                    </Toggle>


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56Fabric);


// WEBPACK FOOTER //
// ./src/X56/X56Fabric.js